<template>
  <div class="login-form">
    <b-form @submit.prevent="handleSubmit">
      <NanInput
        v-model="currentPass"
        :validation="$v.currentPass"
        type="password"
        prependIcon="icon-lock"
        placeholder="Current Password"
        aria-label="Password"
        class="mb-2"
      />

      <NanInput
        v-model="newPass"
        :validation="$v.newPass"
        type="password"
        prependIcon="icon-lock"
        placeholder="New Password"
        class="mb-2"
      />

      <NanInput
        v-model="repeat"
        :validation="$v.repeat"
        type="password"
        prependIcon="icon-lock"
        placeholder="Repeat Password"
        class="mb-2"
      />

      <b-button
        id="password-change-submit"
        :class="{ disabled: $v.$invalid || $store.state.pendingRequests }"
        variant="primary"
        type="submit"
        class="px-4"
        block
      >
        Change Password
      </b-button>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  maxLength,
  minLength,
  required,
  sameAs
} from "vuelidate/lib/validators";
import { password } from "@/helpers/validators";

export default {
  mixins: [validationMixin],

  data: () => ({
    currentPass: "",
    newPass: "",
    repeat: ""
  }),

  methods: {
    async handleSubmit() {
      if (this.$v.$invalid || this.$store.state.pendingRequests) {
        this.$v.$touch();
        return;
      }

      const success = await this.$store.dispatch("user/edit", {
        pass: this.currentPass,
        data: { pass: this.newPass }
      });

      if (success) location.reload();
    }
  },

  validations: {
    newPass: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(250),
      password
    },
    repeat: { required, matches: sameAs("newPass") },
    currentPass: { required, minLength: minLength(8) }
  }
};
</script>
